<template>
  <OsTabGuide
    :ios-images="getLabel('ios')"
    :android-images="getLabel('android')"
  />
</template>
<script setup lang="ts">
const { query } = useRoute()
const { step, direct, code } = query

// 페이지별 이미지 라벨 정의
const guideImageLabel: OsGuideImageLabel = {
  ios: {
    step: {
      integrated: ['img-guide-ios-0', 'img-guide-ios-1-v2', 'img-guide-ios-2-v2', 'img-guide-ios-3-1', 'img-guide-ios-5'], // guide/local
      install: {
        direct: {
          qr: ['img-guide-ios-1-v2', 'img-guide-ios-3-1'], // guide/local?step=install&direct=true&code=qr
          activation: ['img-guide-ios-2-v2', 'img-guide-ios-3-1'] // guide/local?step=install&direct=true&code=activate
        },
        manual: {
          qr: ['img-guide-ios-2-1-v2', 'img-guide-ios-3-1'], // guide/local?step=install&direct=false&code=qr
          activation: ['img-guide-ios-2-v2', 'img-guide-ios-3-1'] // guide/local?step=install&direct=false&code=activate
        }
      },
      activate: ['img-guide-ios-5'] // guide/local?step=activate
    }
  },
  android: {
    step: {
      integrated: ['img-guide-aos-0', 'img-guide-aos-1-1', 'img-guide-aos-2-1', 'img-guide-aos-4'],
      install: {
        direct: {
          qr: ['img-guide-aos-1-1'],
          activation: ['img-guide-aos-2-1']
        },
        manual: {
          qr: ['img-guide-aos-1-1'],
          activation: ['img-guide-aos-2-1']
        }
      },
      activate: ['img-guide-aos-4']
    }
  }
}

// OS에 따라 쿼리 파라미터 조건에 맞는 이미지 라벨을 반환하는 함수
const getLabel = (os: OS): ImageLabel[] => {
  if (!step) {
    return guideImageLabel[os].step.integrated
  }
  if (step === 'install') {
    const method = direct === 'true' ? 'direct' : 'manual'
    if (code) {
      return (
        guideImageLabel[os].step.install[method] as { [key: string]: string[] }
      )[code.toString()]
    }
  } else if (step === 'activate') {
    return guideImageLabel[os].step.activate
  }
  return []
}
</script>
